import { useContext } from 'react'
import { AppContext } from '../contexts/AppContextProvider'

const useAddresses = () => {

    const { customer, addresses } = useContext(AppContext)

    const isDevEnv = () => {

        switch (window.location.origin) {

            case 'https://nobelcomplaints.nobelbiocare.com':

                //PROD
                return false

            case 'https://nobelcomplaints.sta.platform.dental':

                //STA
                return true

            case 'https://nobelcomplaints.dev.platform.dental':

                //DEV
                return true

            case 'https://localhost:5001':

                return true

            default:

                return false
        }
    }
    const getPrimaryAddress = () => {
        return addresses.filter((address) => {

            if( isDevEnv() ) {
                return true
            }
            else {
                return (
                    address.partner === 'Ship-ToParty' &&
                    address.customer === customer.shipToParty
                )
            }

        })[0]
    }

    return {
        getPrimaryAddress,
    }
}

export default useAddresses
